import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomModelNameField, validateModelName } from './CustomModelNameField';

export const CustomModelNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomModelNameField',
    component: CustomModelNameField,
    validation: validateModelName, // This enables form-level validation that blocks navigation
  }),
);

